// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-2IOeHWj0 clearfix","box_r":"box_r-1gCZkbZG","d_box":"d_box-1kMiuQc4"};